"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _AuthorisationWrapper = require("../../AuthorisationWrapper"),
    _requiresPermission = require("../../requiresPermission"),
    _RequestProvider = _interopRequireDefault(require("../../RequestProvider")),
    _PostDetailsForm = _interopRequireDefault(require("../components/PostDetailsForm")),
    _getCampaigns = _interopRequireDefault(require("../api/getCampaigns")),
    _getAllActiveCampaigns = _interopRequireDefault(require("../api/getAllActiveCampaigns"));

function PostDetailsForm(a) {
  var b = a.onFieldChange,
      c = a.onVideoAdd,
      d = a.onThumbnailChange,
      e = a.post,
      f = a.organisationId,
      g = a.assetId,
      h = a.thumbnailUrl,
      i = a.apolloClient;
  return _react["default"].createElement(_RequestProvider["default"], {
    requests: {
      getCampaigns: _getCampaigns["default"],
      getAllActiveCampaigns: _getAllActiveCampaigns["default"]
    }
  }, function (a) {
    var j = a.getCampaigns,
        k = a.getAllActiveCampaigns;
    return _react["default"].createElement(_AuthorisationWrapper.AuthorisationConsumer, null, function (a) {
      var l = a.selectedOrganisation.permissions;
      return _react["default"].createElement(_PostDetailsForm["default"], {
        selectedOrganisationId: f,
        onFieldChange: b,
        onVideoAdd: c,
        onThumbnailChange: d,
        post: e,
        getCampaigns: (0, _requiresPermission.hasPermission)("MANAGE_INSPIRATION_CAMPAIGNS", l) ? j : k,
        apolloClient: i,
        assetId: g,
        thumbnailUrl: h
      });
    });
  });
}

var _default = (0, _react.memo)(PostDetailsForm);

exports["default"] = _default;